module.exports = __webpack_public_path__ + "img/blockshape_s.60e141dc.png";